import '@/scss/style.scss';

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedState from 'pinia-plugin-persistedstate';
import * as Sentry from '@sentry/vue';

import App from './App.vue';
import router from './router';
import { createVuetify } from 'vuetify';
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { LightTheme } from '@/theme/LightTheme.ts';
import { DarkTheme } from '@/theme/DarkTheme.ts';

import { mdiAccountCircle, mdiCircle, mdiClose, mdiEye, mdiEyeOff, mdiHome } from '@mdi/js';

export const icons = {
  close: mdiClose,
  home: mdiHome,
  accountCircle: mdiAccountCircle,
  circle: mdiCircle,
  eye: mdiEye,
  eyeOff: mdiEyeOff
};

const vuetify = createVuetify({
  icons: {
    defaultSet: 'mdi',
    aliases: {
      ...aliases,
      ...icons
    },
    sets: {
      mdi
    }
  },
  theme: {
    defaultTheme: 'Light',
    themes: {
      Light: LightTheme,
      Dark: DarkTheme
    }
  },
  defaults: {
    VBtn: {},
    VCard: {
      rounded: 'md'
    },
    VTextField: {
      rounded: 'lg'
    },
    VTooltip: {
      // set v-tooltip default location to top
      location: 'top'
    }
  },
  components,
  directives
});

const app = createApp(App);

const pinia = createPinia();
pinia.use(piniaPluginPersistedState);
app.use(pinia);

Sentry.init({
  app,
  dsn: 'https://194cb7218255fa62072187a64c330c07@o616915.ingest.us.sentry.io/4508682371530752',
  integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
  tracesSampleRate: 0.1,
  tracePropagationTargets: [/^https:\/\/blickli\.rackow-schulen\.de/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  denyUrls: [/^http:\/\/localhost/]
});

app.use(router);
app.use(vuetify);

app.mount('#app');
